<template>
  <el-container>
    <el-main>
      <h3 class="heading">Edit notification</h3>
      <AutomationForm
        v-if="automationItem && !loading"
        v-model="automationItem"
        :loading="loading"
        action-text="Update"
        @submit="onSubmit"
      />
      <LoadingBlock :loading="loading" />
    </el-main>
  </el-container>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import AutomationForm from '@/apps/traforama/views/automations/components/AutomationForm.vue'
import LoadingBlock from '@/components/LoadingBlock.vue'
import { useAutomationsStore } from '@/store/modules/automations'
import { IAutomation, IAutomationAttributes } from '@/interfaces/automations'
import useValidation from '@/hooks/useValidation'
import { AutomationValidationErrorsKey } from '@/api/types'
import { safeSubmitProcessing } from '@/utils/helpers'
import { ElMessage } from 'element-plus'
import useRouter from '@/hooks/useRouter'

export default defineComponent({
  name: 'EditAutomation',
  components: { AutomationForm, LoadingBlock },
  setup() {
    const route = useRoute()
    const { router } = useRouter()
    const automationsStore = useAutomationsStore()

    const { provideValidation, setValidationErrors } = useValidation(
      AutomationValidationErrorsKey
    )
    const errors = provideValidation()
    const loading = ref(false)
    const automationItem = ref<IAutomationAttributes | null>(null)

    const loadAutomation = async () => {
      loading.value = true
      try {
        const id = route.params.id as string
        const automation = await automationsStore.FetchItem(id)
        automationItem.value = automation.attributes
      } finally {
        loading.value = false
      }
    }

    const onSuccess = () => {
      ElMessage.success({ message: 'Notification has been updated' })
      router.push('/notifications')
    }

    const onSubmit = async ({
      automation
    }: {
      automation: IAutomationAttributes
    }) => {
      errors.value = {}
      await safeSubmitProcessing(
        loading,
        () => automationsStore.UpdateAutomation(automation),
        () => onSuccess(),
        (err) => setValidationErrors(err, errors)
      )
    }

    onMounted(async () => {
      await automationsStore.getAutomationEvents()
      await loadAutomation()
    })

    return { automationItem, loading, onSubmit }
  }
})
</script>
